import {
    FormControl,
    FormHelperText,
    Grid,
    Typography,
    useTheme,
} from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import SpaceCardContent from './SpaceCardContent';

interface Space {
    id: number;
    spaceType: string;
    name: string;
    isAvailable?: boolean;
    cleaningFee?: number;
    [key: string]: any;
}

interface FormCardSelectProps {
    name: string;
    control: Control<any>;
    spaces: Space[];
    spaceType?: string;
}

const FormCardSelect = ({
    name,
    control,
    spaces,
    spaceType,
}: FormCardSelectProps) => {
    const theme = useTheme();

    const label =
        spaceType === 'meetingRoom'
            ? 'Select your meeting room'
            : spaceType === 'privateOffice'
              ? 'Select your office'
              : 'Select required spaces';
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange, value = [] },
                fieldState: { error },
            }) => {
                const selectedIds = Array.isArray(value) ? value : [];

                const handleCardClick = (spaceId: number) => {
                    const isSingleSelect = [
                        'meetingRoom',
                        'privateOffice',
                    ].includes(spaceType ?? '');
                    if (selectedIds.includes(spaceId)) {
                        onChange(
                            selectedIds.filter((id: number) => id !== spaceId),
                        );
                        return;
                    }
                    if (isSingleSelect) {
                        onChange([spaceId]);
                    } else {
                        onChange([...selectedIds, spaceId]);
                    }
                };

                return (
                    <FormControl fullWidth error={!!error}>
                        <Typography
                            variant='h6'
                            sx={{
                                mb: 2,
                                fontSize: '16px',
                                color: 'text.primary',
                            }}
                        >
                            {label}
                        </Typography>
                        <Grid container spacing={2}>
                            {spaces
                                ?.filter((space: any) => space.cleaningFee > 0)
                                .map((space) => {
                                    const isSelected = selectedIds.includes(
                                        space.id,
                                    );

                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            key={space.id}
                                        >
                                            <SpaceCardContent
                                                shouldShowSelected={true}
                                                space={space}
                                                isSelected={isSelected}
                                                handleCardClick={
                                                    handleCardClick
                                                }
                                                isReservationForm={false}
                                                isExperienceForm={true}
                                            />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                        {!!error && (
                            <FormHelperText error>
                                {error.message}
                            </FormHelperText>
                        )}
                    </FormControl>
                );
            }}
        />
    );
};

export default FormCardSelect;
